const DB_NAME = 'JadwalhDB';
const DB_VERSION = 3;

export function storeDataInIndexedDB(
  languageData: Array<{ label: string; value: string }>,
  countryData: Array<{ label: string; value: string }>
) {
  const request = window.indexedDB.open(DB_NAME, DB_VERSION);

  request.onerror = function (event) {
    console.error('Database error: ' + (event.target as IDBOpenDBRequest).error);
  };

  request.onupgradeneeded = function (event) {
    const db = (event.target as IDBOpenDBRequest).result;

    if (!db.objectStoreNames.contains('languages')) {
      const store = db.createObjectStore('languages', { keyPath: 'value' });
      store.createIndex('value', 'value', { unique: false });
    }

    if (!db.objectStoreNames.contains('countries')) {
      const store = db.createObjectStore('countries', { keyPath: 'value' });
      store.createIndex('value', 'value', { unique: false });
    }
  };

  request.onsuccess = function (event) {
    const db = (event.target as IDBOpenDBRequest).result;

    db.onversionchange = function () {
      db.close();
      alert('Database is outdated, please reload the page.');
    };

    if (
      !db.objectStoreNames.contains('languages') ||
      !db.objectStoreNames.contains('countries')
    ) {
      console.error('Object stores do not exist.');
      return;
    }

    const languageTransaction = db.transaction(['languages'], 'readwrite');
    const languageObjectStore = languageTransaction.objectStore('languages');
    languageData.forEach((item) => languageObjectStore.put(item));
    languageTransaction.onerror = function (event) {
      console.error('Error storing language data: ' + (event.target as IDBTransaction).error);
    };

    const countryTransaction = db.transaction(['countries'], 'readwrite');
    const countryObjectStore = countryTransaction.objectStore('countries');
    countryData.forEach((item) => countryObjectStore.put(item));
    countryTransaction.onerror = function (event) {
      console.error('Error storing country data: ' + (event.target as IDBTransaction).error);
    };
  };
}
